import Typography from '@mui/material/Typography'
import * as React from 'react'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

type Props = {
  title: string
  description: string
  type?: 'error' | 'info'
  children?: React.ReactNode
}

export function FormPacketErrorAlert(props: Props) {
  const { title, description, type, children } = props
  return (
    <Alert
      sx={{
        display: 'flex',
        alignItems: 'start',
      }}
      severity={type || 'error'}
    >
      <Box mb={0.5}>
        <AlertTitle>
          <Typography
            variant="subtitle1"
            sx={{
              lineHeight: '24px',
              fontWeight: '600',
            }}
            color={type === 'info' ? '#013654' : '#541313'}
          >
            {title}
          </Typography>
        </AlertTitle>
      </Box>
      <Typography variant="body2">{description}</Typography>
      {children}
    </Alert>
  )
}
